import { AdministrationView as BaseAdministrationView } from 'modules/administration/common/views';

import { FormFooter } from '../../common/components/FormFooter';
import {
  AccountingSystemForm,
  AccountingSystemFormContent,
  AccountingSystemActions,
  AccountingSystemFormProps,
} from '../components';

interface Props extends AccountingSystemFormProps {
  submitLoading?: boolean;
}

export const AccountingSystemView = ({
  initialValues,
  submitLoading,
  onSubmit,
}: Props) => (
  <AccountingSystemForm initialValues={initialValues} onSubmit={onSubmit}>
    <BaseAdministrationView
      headerRightContent={<AccountingSystemActions />}
      tabValue="accountingSystem"
    >
      <AccountingSystemFormContent />
      <FormFooter submitLoading={submitLoading} />
    </BaseAdministrationView>
  </AccountingSystemForm>
);
